import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "tropikal_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => { if (t) localStorage.setItem(TOKEN_KEY, t); };
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const http = axios.create({ baseURL: API });

http.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const api = {
  // auth
  register: async (data) => {
    const { data: res } = await http.post("/auth/register", data);
    setToken(res.token);
    return res;
  },
  login: async (data) => {
    const { data: res } = await http.post("/auth/login", data);
    setToken(res.token);
    return res;
  },
  emergentSession: async (session_id, ref) => {
    const { data: res } = await http.post("/auth/session", { session_id, ref });
    setToken(res.token);
    return res;
  },
  me: () => http.get("/auth/me").then((r) => r.data),
  forgotPassword: (email, lang) => http.post("/auth/forgot-password", { email, lang }).then((r) => r.data),
  resetPassword: async (token, password) => {
    const { data: res } = await http.post("/auth/reset-password", { token, password });
    setToken(res.token);
    return res;
  },
  logout: async () => {
    try { await http.post("/auth/logout"); } catch (e) {
      if (process.env.NODE_ENV !== "production") console.warn("Logout request failed, clearing local token anyway:", e?.message);
    }
    clearToken();
    return { ok: true };
  },
  // recipes
  listRecipes: (params = {}) => http.get("/recipes", { params }).then((r) => r.data),
  featuredRecipes: () => http.get("/recipes/featured").then((r) => r.data),
  countries: () => http.get("/recipes/countries").then((r) => r.data),
  getRecipe: (slug) => http.get(`/recipes/${slug}`).then((r) => r.data),
  submitRecipe: (payload) => http.post("/recipes", payload).then((r) => r.data),
  myRecipes: () => http.get("/me/recipes").then((r) => r.data),
  getMyRecipe: (recipe_id) => http.get(`/me/recipes/${recipe_id}`).then((r) => r.data),
  updateMyRecipe: (recipe_id, payload) => http.put(`/recipes/${recipe_id}`, payload).then((r) => r.data),
  // selections + community
  listSelections: () => http.get("/selections").then((r) => r.data),
  getSelection: (slug) => http.get(`/selections/${slug}`).then((r) => r.data),
  testimonials: () => http.get("/testimonials").then((r) => r.data),
  subscribeNewsletter: (email) => http.post("/newsletter/subscribe", { email }).then((r) => r.data),
  requestEbook: (email, lang) => http.post("/ebook/request", { email, lang }).then((r) => r.data),
  // shop
  listProducts: (params = {}) => http.get("/products", { params }).then((r) => r.data),
  getProduct: (slug) => http.get(`/products/${slug}`).then((r) => r.data),
  createOrder: (payload) => http.post("/orders", payload).then((r) => r.data),
  myOrders: () => http.get("/me/orders").then((r) => r.data),
  orderDownloads: (order_id) => http.get(`/orders/${order_id}/downloads`).then((r) => r.data),
  // stripe checkout
  createCheckoutSession: (payload) => http.post("/checkout/session", payload).then((r) => r.data),
  checkoutStatus: (session_id) => http.get(`/checkout/status/${session_id}`).then((r) => r.data),
  // admin (requires X-Admin-Token header)
  contact: (payload) => http.post("/contact", payload).then((r) => r.data),

  // Referral
  myReferral: () => http.get("/referral/me").then((r) => r.data),
  validateReferral: (code) => http.post("/referral/validate", { code }).then((r) => r.data),

  // Gamification
  myGamification: () => http.get("/gamification/me").then((r) => r.data),
  leaderboard: (scope = "month", limit = 3) => http.get(`/gamification/leaderboard?scope=${scope}&limit=${limit}`).then((r) => r.data),

  adminLeads: (token) => http.get("/admin/leads", { headers: { "X-Admin-Token": token } }).then((r) => r.data),
  adminStats: (token) => http.get("/admin/stats", { headers: { "X-Admin-Token": token } }).then((r) => r.data),
  adminPendingRecipes: (token) => http.get("/admin/recipes/pending", { headers: { "X-Admin-Token": token } }).then((r) => r.data),
  adminApproveRecipe: (token, recipe_id) => http.post(`/admin/recipes/${recipe_id}/approve`, {}, { headers: { "X-Admin-Token": token } }).then((r) => r.data),
  adminRejectRecipe: (token, recipe_id, reason) => http.post(`/admin/recipes/${recipe_id}/reject`, { reason: reason || "" }, { headers: { "X-Admin-Token": token } }).then((r) => r.data),
  // reviews
  listReviews: (slug) => http.get(`/recipes/${slug}/reviews`).then((r) => r.data),
  postReview: (slug, payload) => http.post(`/recipes/${slug}/reviews`, payload).then((r) => r.data),
};
